import { useEffect, useRef, useState } from "react";

interface VersionInfo {
  version: string;
  commit: string;
}

/**
 * Erkennt neue Deployments über /api/v1/version (ARCHITEKTUR §10.6).
 * Neu geladen wird nur, wenn `isSafe()` true liefert – nie mitten in einem Vorgang.
 */
export function useVersionWatcher(isSafe: () => boolean, intervalMs = 60_000): boolean {
  const first = useRef<VersionInfo | null>(null);
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const safeRef = useRef(isSafe);
  useEffect(() => {
    safeRef.current = isSafe;
  });

  useEffect(() => {
    let stopped = false;
    const check = async () => {
      try {
        const r = await fetch("/api/v1/version", { cache: "no-store" });
        if (!r.ok) return;
        const v = (await r.json()) as VersionInfo;
        if (!first.current) first.current = v;
        else if (v.version !== first.current.version || v.commit !== first.current.commit) {
          if (safeRef.current()) location.reload();
          else if (!stopped) setUpdateAvailable(true);
        }
      } catch {
        /* offline – nächster Versuch im Intervall */
      }
    };
    void check();
    const id = window.setInterval(() => void check(), intervalMs);
    return () => {
      stopped = true;
      window.clearInterval(id);
    };
  }, [intervalMs]);

  return updateAvailable;
}
